<template>
    <div v-if="bizAuth.viewLandlord.hasRight" class="page-setting biz-landlord-mgt parent-frame" :class="{'fixed': listIsFixed}"  v-bind:style="{'min-height': myHeight}">
        <div class="tool-bar-mask"></div>
        <div class="page-header">
            <h1>{{$route.meta.title}}</h1>
            <div class="btn-group">
                <table-search @changeWord="setFilterWord" :setDefault="isDefault" ></table-search>
                <div v-if="bizAuth.createLandlord.hasRight" class="default-button publish" @click="newLandlord">
                    新增
                </div>
            </div>
        </div>
        <landlord-mgt-list></landlord-mgt-list>
    </div>
</template>
<script>
import TableSearch from '@/components/widge/TableSearch.vue';
import landlordMgtList from '@/components/bussiness/mgtCategory/landlordMgt/landlordMgtList.vue';

import { mapGetters } from 'vuex'

export default {
    data () {
        return {
            listIsFixed: false,
            myHeight: (window.innerHeight - 84) + 'px',
            isFilter: false,
            isDefault: false
        }
    },
    mounted () {
        this.$analyticsBiz.logEvent(this.$route.meta.title, { screen_name: this.$route.meta.title})
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
        document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'flex'
    },
    watch: {
        'bizAuth.viewLandlord.hasRight': function (val) {
            if(!val){
                this.$store.dispatch('setModalStatus', {state: true, type: 'bizNoRight'})
            }
        },
        filterWord: function (val){
            if(!val){
                this.isDefault = true
                setTimeout(()=>{
                    this.isDefault = false
                }, 500)
            }
        }
        
    },
    methods: {
        handleScroll: function () {
            if(!this.isModalMode){
                let scrollTop = event.target.documentElement.scrollTop
                if( scrollTop >= 50){
                    document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'none'
                    document.getElementsByClassName('parent-frame')[0].style.zIndex = '7'
                }else{
                    document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'flex'
                    document.getElementsByClassName('parent-frame')[0].style.zIndex = '7'
                    this.listIsFixed = false
                }

                if( scrollTop >= 115){
                    this.listIsFixed = true
                }
            }
        },
        openFilter: function () {
            this.isFilter = true
            this.$store.commit('modalStatus/set_filter_mode', true)
            document.getElementsByClassName('parent-frame')[0].style.zIndex = '8'
        },
        closeFilter: function (value) {
            this.isFilter = value
            this.$store.commit('modalStatus/set_filter_mode', false)
        },
        setFilterWord: function (value) {
            // TODO
            this.$store.dispatch('setlBizLandlordFilterWord', value)
            console.log(value)
        },
        setFilterQuery: function (value) {
            // TODO
            console.log(value)
        },
        newLandlord: function () {
            if(this.verifiedStatus === 'NORMAL'){
                this.$router.push({name: 'bizAddLandlord'})
            }else{
                this.$store.dispatch('bizSetVerifiedAlarmBling', 200)
            }
        }
    },
    computed: {
        ...mapGetters({
            bizAuth: 'GET_BIZ_AUTH',
            verifiedStatus: 'GET_BIZ_COMPANY_IS_VERIFIED',
            filterWord: 'GET_BIZ_LANDLORD_FILTER_WORD',
        })
    },
    components: {
        TableSearch,
        landlordMgtList,
    }
}
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/pages/bussiness/mgtCategory/landlordMgt/landlordMgtDefault.vue